import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VersionManagerPipe } from '@wms/app/core/utils/version-manager-pipe';
import {
  NotificationService,
  DialogService,
  PrefabService,
} from '@wms/app/services';
import { BaseComponent, WmsDialogComponent } from '@wms/components';
import { WmsDialogFooterComponent } from '../../components/wms-dialog-footer/wms-dialog-footer.component';
import { WmsDialogHeaderComponent } from '../../components/wms-dialog-header/wms-dialog-header.component';
import { WmsDialogBodyComponent } from '../../components/wms-dialog-body/wms-dialog-body.component';
import { FormsModule } from '@angular/forms';
import { SearchComponent } from "../../components/search/search.component";
import { WmsMessageComponent } from "@wms/components";
import { PrefabPublishService } from '../prefab-publish.service';
import { PrefabManager } from '@wms/app/workspace/page-workspace/prefabs/prefab-manager';
import { get, isObject } from 'lodash-es';
import { replace } from '@wm/core';

@Component({
  selector: 'wms-publish-to-project',
  standalone: true,
  templateUrl: './publish-to-project.component.html',
  styleUrls: ['./publish-to-project.component.less'],
  imports: [
    WmsDialogComponent,
    WmsDialogHeaderComponent,
    WmsDialogBodyComponent,
    WmsDialogFooterComponent,
    CommonModule,
    FormsModule,
    SearchComponent,
    WmsMessageComponent
  ]
})
export class PublishToProjectComponent extends BaseComponent {
  selectedValue: any;
  copyProjects: any;
  searchValue: string;
  message: any
  showErrorMessage: boolean = false
  @ViewChild(SearchComponent) searchComponent: SearchComponent
  protected projectAvatarPath: string = this.versionManager.transform(
    'assets/images/provatars/'
  );
  constructor(
    private dialogService: DialogService,
    private versionManager: VersionManagerPipe,
    private notificationService: NotificationService,
    public prefabPublishService: PrefabPublishService,
    public prefabService: PrefabService,
    public prefabManager:PrefabManager
  ) {
    super();
  }
  onRadioChange() {
    this.prefabPublishService.oldSelectedProject = this.prefabPublishService.selectedProject
    this.selectedValue = this.prefabPublishService.prefabToProjectList.find(element => element.projectId === this.prefabPublishService.selectedProject);
  }
  showErrMsg(msg: string) {
    this.showErrorMessage = true;
    this.message = {
      type: 'error',
      caption: msg
    };
  }

  closeDialogWithId(id: string): void {
    this.prefabPublishService.selectedProject = ''
    this.dialogService.close(id);
    this.showErrorMessage = false;
    this.searchComponent.clearSearch();
  }

  filterServices(data: string) {
    if (data.trim() === '') {
      this.prefabPublishService.prefabToProjectList = this.copyProjects;
    } else {
      this.copyProjects = this.prefabPublishService.copyPrefabToProjectList;
      let projects: any[] = this.copyProjects;
      let filteredServices = projects.filter((service: any) => {
        if (service.name.toLowerCase().includes(data.toLowerCase()) || service.vcsBranch?.toLowerCase().includes(data.toLowerCase()))
          return service;
      });
      this.prefabPublishService.prefabToProjectList = filteredServices;
    }
  }
  publishPrefabToProject() {
    this.showErrorMessage = false;
    const projectDetails = this.projectService.getDetails();
    const data = {
        targetProjectId: this.selectedValue.studioProjectId,
        prefabName: projectDetails.name,
        version: projectDetails.version,
    };
    (
      this.prefabService.updatePrefabs(
        'false',
        data,
        this.projectService.getProjectId()
      ) as Promise<any>
    )
      .then((response: any) => {
        this.closeDialogWithId('publish-to-project');
        this.notificationService.show(
          response.result,
          this.locale['MESSAGE_SUCCESS_TITLE'],
          this.locale['MESSAGE_PUBLISH_SUCCESS']
        );
      },(response:any) =>{
        let errObj = response.error ? response.error : response;
        this.publishToProjectErrorHandler(this.selectedValue.studioProjectId,errObj)
      })

  }
  assignSelectedProject(project: any) {
    this.prefabPublishService.selectedProject = this.prefabPublishService.oldSelectedProject = project.projectId
    this.selectedValue = project
  }
  //error handler for publishing the prefab to the project
  publishToProjectErrorHandler(targetProjectId: any, errObj:any) {
    if (errObj && this.prefabManager.isPrefabVersionConflictError(errObj)) {
        this.dialogService.open('prefabConflictDialog', {
            'resolve': {
                'dialogParams': () => {
                    return {
                        'error': errObj,
                        'projectId': targetProjectId,
                        'pushToProj': true,
                        'onOk': () =>{},
                        'forceRegisterSuccess':  () => {
                            this.closeDialogWithId('publish-to-project');
                            this.notificationService.show(
                              'success',
                              this.locale['MESSAGE_SUCCESS_TITLE'],
                              this.locale['MESSAGE_PUBLISH_SUCCESS']
                            );
                        }
                    };
                }
            }
        });
    } else {
      this.showErrorMessage = true;
      this.message = {
        type: 'error',
        caption: !isObject(errObj) ? errObj : replace(get(errObj, 'errors.error[0].message') || '', get(errObj, 'errors.error[0].parameters'), true)
      }
    }
  }

}
